import { useQuery } from "@tanstack/react-query";
import {useMemo} from "react";
import { useParams } from "react-router-dom";

import styles from "./ProjectHeader.module.scss";
import { ProjectHeaderPlaceholder } from "./ProjectHeaderPlaceholder";

import { getProjectHeader } from "../../../../../api/projectSummary/projectSummary";
import { useUserData } from "../../../../../hooks/useUserProfile";
// import { useAppSelector } from "../../../../../store/hooks/hooks";
// import { selectCurrentId } from "../../../../../store/slices/stepSlice";
import { HeaderDashBoard } from "../../../../../types/previewTemplate";
import { HeaderLogo } from "../../../HederLogo";
import { InfoTiles } from "../InfoTiles";

export const ProjectHeader = () => {
  // TODO: handle currentId properly
  // currentId ? currentId : reportId,
  // const currentId = useAppSelector(selectCurrentId);

  const { organizationId, tenantId } = useUserData();
  const { reportId, syncLogId } = useParams();

  const { data: headerInfo, isLoading } = useQuery({
    queryKey: ["projectHeader",reportId, syncLogId, organizationId, tenantId],
    queryFn: async (): Promise<HeaderDashBoard> => {
      const data = await getProjectHeader(
        syncLogId!,
        organizationId,
        tenantId
      );

      return data.data.data;
    },
    enabled: !!tenantId && !!syncLogId,
  });

  const infoReportList = useMemo(() => [
    { id: "1", value: headerInfo?.count, title: "Count of Projects" },
    { id: "2", value: `$${headerInfo?.budgetCost}K`, title: "Budget Cost" },
    { id: "3", value: `${headerInfo?.average}%`, title: "Average %" },
    { id: "4", value: `$${headerInfo?.actualCost}K`, title: "Actual Cost" },
  ], [headerInfo]);

  if (isLoading) {
    return <ProjectHeaderPlaceholder />;
  }

  return (
    <div className={styles.root}>
      <HeaderLogo title={headerInfo?.reportName} />
      <div className={styles.infoWrapper}>
        {infoReportList.map((item) => (
          <InfoTiles key={item.id} title={item.title} value={item.value} />
        ))}
      </div>
    </div>
  );
};
